<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  watch: {
    '$route' (to) {
      document.title = `${typeof to.meta.title != undefined ? `${to.meta.title} |` : ''} Arcphysx Personal Site`
    }
  },
}
</script>